"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var coupons_html_1 = __importDefault(require("./coupons.html"));
var coupons_controller_1 = __importDefault(require("./coupons.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.coupons", {
        url: "/coupons",
        template: coupons_html_1.default,
        controller: coupons_controller_1.default,
        controllerAs: "vm",
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.crm.coupons", [])
    .config(config)
    .controller("CouponsController", coupons_controller_1.default);
